
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/intro",
      function () {
        return require("private-next-pages/intro/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/intro"])
      });
    }
  